import { ReservationTimeSettings } from "../types/settings-types";

export const DEFAULT_TIME_SETTINGS: ReservationTimeSettings = {
  start_hour: 9,
  start_minutes: 0,
  meeting_room_duration: 1,
  desk_duration: 8
};
